module.exports = __webpack_public_path__ + "static/media/Recaudacion-de-Impuestos.6d0d8237.jpg";